// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4":"05447a02","118":"564445f2","299":"5d540169","377":"63bb46ce","474":"8ad37ef5","728":"2070073a"}[chunkId] + ".css";
};